<template>
  <div class="recharge">
    <mt-loadmore
      :bottom-method="ChangeQueryRecord"
      :autoFill="false"
      ref="loadmore"
    >
      <div class="bg_color">
        <div class="bg_head">
          <div class="head_content">
            <img class="head_img" :src="logoUrl" />
          </div>
        </div>

        <p class="money_num">￥{{ moneys }}</p>
      </div>
      <div class="mains">
        <div class="main_item" v-for="(item, index) in dataList" :key="index">
          <div class="item_left">
            <div class="left_top">{{ item.SHPNAME }}</div>
            <div class="left_bottom">{{ item.DOCDATE }}</div>
          </div>
          <div class="item_right">￥{{ item.AMT }}</div>
        </div>
      </div>
      <div class="none_list" v-if="dataList.length == 0">
        <img class="main_headimg" src="/static/image/chongzhijilu.png" />
        <p class="main_text">还没有充值记录哦！</p>
      </div>
      <!-- <loading v-if="load"></loading> -->
      <div slot="bottom" class="mint-loadmore-bottom">
        <span v-show="load">松手释放↑</span>

        <!-- <span v-show="scrollFalse">没有更多数据啦！</span> -->
      </div>
    </mt-loadmore>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  data() {
    return {
      // dateVal:'全部'
      load: false,
      page: 1,
      scrollFalse: true,
      moneys: 0,
      dataList: [],
      logoUrl: '/static/image/jilu.png',
    }
  },
  mounted() {
    this.ChangeQueryRecord(this.page)
  },
  methods: {
    setDate(e) {
      this.dateVal = e.target.value
      console.log(e.target.value, 'hjfshdkjfhsdkfjkskfjkjfkjsd')
    },
    // scrollEvent() {
    //   if (this.scrollFalse) {
    //     if (
    //       this.$refs.app.offsetHeight +
    //         this.$refs.app.scrollTop -
    //         this.$refs.app.scrollHeight ==
    //       0
    //     ) {
    //       this.page += 1
    //       this.ChangeQueryRecord(this.page)
    //     }
    //   }
    // },
    ChangeQueryRecord() {
      if (!this.scrollFalse) {
        return
      }
      this.load = true
      this.scrollFalse = false

      this.appcode = localStorage.getItem('appcode')
      this.code = localStorage.getItem('code')
      this.vipno = localStorage.getItem('VIPNO')
      this.moneys = Number(localStorage.getItem('Money')).toFixed(2)
      const companyID = localStorage.getItem('companyID')
      this.RequestVIP(
        `h5/vip/recharge/history/v2?openID=${this.code}&vipno=${this.vipno}&CompanyID=${companyID}&size=20&page=${this.page}`,
        (r) => {
          if (r.data.data.table1 != undefined && r.data.data.table1.length) {
            // console.log(r.data.table1[0].SHPNAME)
            this.dataList = [...this.dataList, ...r.data.data.table1]
            this.scrollFalse = true
            this.page += 1
          } else {
            this.scrollFalse = false
          }
          this.load = false
          this.$refs.loadmore.onBottomLoaded()
        },
        (err) => {
          console.log(err)
          this.load = true
        }
      )
    },
  },
}
</script>
<style scoped>
.recharge {
  font-size: 8px;
  width: 100%;
  height: 98vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
.none_list {
  position: fixed;
  top: 40%;
  left: 42%;
  text-align: center;
}
.main_headimg {
  width: 40px;
  height: 40px;
}
.bg_color {
  width: 250px;
  height: 110px;
  background: linear-gradient(310deg, #ff9c60 0%, #ff5a61 100%);
  opacity: 1;
  text-align: center;
  box-sizing: border-box;
  padding: 20px 0 11px;
}
.bg_head {
  width: 44px;
  margin: 0px auto;
  height: 44px;
  background: rgba(255, 255, 255, 0.38);
  border-radius: 50%;

  text-align: center;
  position: relative;
}
.head_content {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 3px;
  left: 3px;
  background: #ffffff;
  border-radius: 50px;
  border: none;
  opacity: 1;
}
.head_img {
  width: 20px;
  height: 20px;
  /* border-radius: 50px; */
  margin: 9px 0 0;
}
.leave_money {
  /* height: 14px; */
  font-size: 9px;
  padding: 30px 0;
  width: 100%;
  margin-left: 25px;
  font-weight: 400;
  color: #212121;
  opacity: 1;
}
.money_num {
  height: 42px;
  font-size: 17px;
  margin-top: 11px;
  /* width: 100%;
  margin-left: 23px; */
  font-weight: 500;
  line-height: 18px;
  color: #ffffff;
  opacity: 1;
}
.search {
  width: 90%;
  height: 25px;
  margin: 4px auto;
  background: white;
  z-index: 999;
  display: flex;
  line-height: 25px;
  padding: 0px 10px;
  font-size: 9px;
  box-sizing: border-box;
  font-weight: 500;
  justify-content: space-between;
  position: relative;
}
.mains {
  width: 100%;
  background: white;
  padding: 5px;
  overflow: scroll;
  box-sizing: border-box;
}

.main_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  padding: 10px 0;
  border-bottom: solid 1px lightgray;
}
.left_top,
.item_right,
.titles {
  font-weight: 600;
}
.titles {
  pointer-events: none;
  position: absolute;
  right: 8px;
  z-index: 999;
}
.item_right {
  font-size: 10px;
  font-weight: 400;
  color: #f2553d;
}
.left_top {
  font-size: 10px;
  color: #212121;
}
.left_bottom {
  font-size: 8px;
  color: #9e9e9e;
  margin-top: 11px;
}
</style>



// WEBPACK FOOTER //
// src/Detail/index.vue